const roomName = "lobby"
const pageBackgroundURL = "https://assets.swoogo.com/uploads/1334997-6138ed3704b2e.mp4";

const extras = <>
                <iframe src="https://www.youtube.com/embed/-TXtUQl4REM?autoplay=1&mute=1" allow="autoplay" loop style="position:absolute ; width:14.4%;  height:17.4% ; left:8.6% ; top:33.2% "></iframe>
            
            </>

// export const extras = html`<script src="https://apps.elfsight.com/p/platform.js" defer><//>`

const links = [
    { label: "intel", width: "14.4%", height: "17.4%", left: "8.6%", top: "33.2%", href: "#intel" },
    { label: "info-desk", width: "22.4%", height: "35.4%", left: "2.6%", top: "56.2%", href: "#intel", title: "Info Desk",  onClick: () => {window.smartsupp("chat:open")}},
    { label: "Lounge", width: "37%", height: "52.8%", left: "31.5%", top: "25.2%", href: "/lounge", isExternal: true, title: "Pre-screening Lounge" },
    { label: "photobooth", width: "22.9%", height: "61.0%", left: "72.6%", top: "28.0%", href: "https://snapshotphotobooth.vbth.app/dell", target: "blank", title: "Take a Selfie!" },
    { label: "2021-sept-TIFF-welcome-popup", elfsightPopupTrigger: "2021-sept-TIFF-welcome-popup", elfsightPopupID: "ea606ac0-833a-4e9a-82fc-75b4c915a16c", popupFrequency: "daily" },
    //{ label: "onC", width: "26%", height: "20%", left: "37%", top: "75%", onClick: () => {console.log("hello world")} },
];

export default { default: true, extras, links, roomName, pageBackgroundURL, styles: "height: calc(100vw * 434.533/878)" };                          
// onClick: openchat()
